import { CopyCard } from "../CopyCard";
import { AddressDescriptionProps } from "./types";
import { useClipboard } from "@/hooks";

export function AddressDescription({ name, address }: AddressDescriptionProps) {
  const { handleCopy } = useClipboard();

  return (
    <div className="w-full flex flex-col gap-[5px]">
      <p className="text-base text-left font-medium text-cede-text-primary w-full">Address Description</p>
      <CopyCard testId="name-copy-icon" title={"Address Name"} content={name} onCopy={() => handleCopy(name)} />
      <p className="text-base text-left font-medium text-cede-text-primary w-full mt-[13px]">Address</p>
      <CopyCard testId="address-copy-icon" title="Address" content={address} onCopy={() => handleCopy(address)} />
    </div>
  );
}
